import { useToast } from 'primevue/usetoast'

export function useCopy() {
  const toast = useToast()

  const copyText = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text)
      toast.add({
        severity: 'success',
        summary: 'Copied',
        detail: 'Text copied to clipboard',
        life: 3000,
      })
    }
    catch (err) {
      console.error(err)
      toast.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to copy text',
        life: 3000,
      })
    }
  }

  return {
    copyText,
  }
}
